module.exports = __webpack_public_path__ + "img/120.70f39163.svg";